
const parseMentions = (text: string) => {
    const regex = /@([a-zA-Z0-9._]+)/g;
    const parts = text.split(regex);

    return parts.map((part, i) => {
        if (i % 2 === 1) {
            return (
                <a
                    key={i}
                    href={`https://instagram.com/${part}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mention"
                >
                    @{part}
                </a>
            );
        }
        return part;
    });
};

interface CommentTextProps {
    username: string;
    text: string;
}


const CommentText = ({ username, text }: CommentTextProps) => {
    return (
        <div className="comment-text">
            <a target='_blank' className='text-dark' href={`https://instagram.com/${username}`}><strong>@{username}</strong>{" "}</a>
            <span>{parseMentions(text)}</span>
        </div>
    );
};

export default CommentText;